import { siteKey } from "../../../packs/utils/grecaptcha.js.erb";
import { awaitForReCaptchaLoad } from "../../utils/functions";

const reCaptchaIntervals = [];

const injectRecaptchaToken = (elem) => {
  window.grecaptcha.execute(siteKey.V3, { action: elem.dataset.recaptchamode }).then((token) => {
    // eslint-disable-next-line no-param-reassign
    document.getElementById(`g-recaptcha-response-data-${elem.value}`).value = token;
  });
};

const clearRecaptchaIntervals = () => {
  reCaptchaIntervals.forEach((int) => {
    clearInterval(int);
  });
};

const formRecaptcha = (forModal = true) => {
  const recaptchaInputs = document.querySelectorAll(".js-form-recaptcha");

  clearRecaptchaIntervals();

  awaitForReCaptchaLoad().then(() => {
    window.grecaptcha.ready(() => {
      recaptchaInputs.forEach((elem) => {
        injectRecaptchaToken(elem);
        const interval = setInterval(injectRecaptchaToken.bind(this, elem), 60000);
        if (forModal) reCaptchaIntervals.push(interval);
      });
    });
  });
};

document.addEventListener("recaptchaRefresh", formRecaptcha);
document.addEventListener("recaptchaRefreshStop", clearRecaptchaIntervals);

formRecaptcha(false);
